var map = {
	"./arabian-woman.jpg": 9208,
	"./business.jpg": 8726,
	"./commitments.jpg": 5383,
	"./compliance.jpg": 8015,
	"./csr.jpg": 329,
	"./embedding.jpg": 6027,
	"./emissions.jpg": 4113,
	"./environment.jpg": 9276,
	"./esg-profile.jpg": 1783,
	"./governence.jpg": 2974,
	"./highlight.jpg": 7422,
	"./international-frameworks.jpg": 739,
	"./journey.jpg": 3978,
	"./reports.jpg": 9972,
	"./resource.jpg": 2019,
	"./risk.jpg": 8669,
	"./saudi-green.jpg": 5101,
	"./stakeholders.jpg": 947,
	"./statements-2.jpg": 3960,
	"./statements.jpg": 7458,
	"./transtion.jpg": 3760,
	"./vision.jpg": 935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9343;